// External Imports
import { useState, useEffect } from "react";
import { MdClose } from "react-icons/md";

// Internal Imports
import { requestAdminAPI } from "../../api/posh-api";
import { isoDateToString } from "../../util/format-date";
import Heading from "../UI/Heading";
import Modal from "../UI/Modal";
import DetailPair from "../UI/DetailPair";
import PersonCard from "../UI/PersonCard";

// ** ========================================================================
// * * Bank Account Information Modal
// * Renders a modal, which displays all information about a bank account.
// * ========================================================================== */

export default function BankAccountInfoModal({
  open,
  setOpen,
  accountId,
  refresh,
}) {
  // Initialize States
  const [account, setAccount] = useState({});
  const [loading, setLoading] = useState(true);

  // =================== FETCH RECORD ===================
  const fetchRecord = async () => {
    try {
      setLoading(true);
      const response = await requestAdminAPI("fetch", {
        table: "account",
        id: accountId,
        columns: ["createdBy { name phone, photo  }"],
      });
      setAccount(response);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  // =================== USE_EFFECT ===================
  useEffect(() => {
    if (accountId && open) fetchRecord();
  }, [open, accountId]);

  return (
    <Modal open={open} setOpen={setOpen}>
      <div className="modal max-w-[600px]">
        <Heading
          title="Bank Account Information"
          id={accountId}
          isBackArrow={false}
        >
          <MdClose className="icon" onClick={() => setOpen(false)} />
        </Heading>

        <div className="info lg:grid-cols-3">
          <DetailPair
            label="Date Created"
            value={isoDateToString(account.dateCreated)}
            loading={loading}
          />
          <DetailPair
            label="Bank Name"
            value={account.bank}
            loading={loading}
          />
          <DetailPair label="Type" value={account.type} loading={loading} />
          <DetailPair
            label="Account Number"
            value={account.account}
            loading={loading}
          />
          <DetailPair
            label="Routing Number"
            value={account.routing}
            loading={loading}
          />
        </div>

        <div className="info lg:grid-cols-3">
          <div className="col-start-3">
            <PersonCard
              link={`/employees/info?id=${account.createdById}`}
              label="Created By"
              name={account.createdBy?.name}
              secondary={account.createdBy?.phone}
              image={account.createdBy?.photo}
              loading={loading}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}
